import React from 'react';

const SvgBf = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BF_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BF_svg__b" fill="#fff">
        <use xlinkHref="#BF_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BF_svg__a" />
      <path fill="#00B051" mask="url(#BF_svg__b)" d="M0 10.667h28V20H0z" />
      <path fill="#FA494B" mask="url(#BF_svg__b)" d="M0 0h28v10.667H0z" />
      <path
        fill="#FDD216"
        mask="url(#BF_svg__b)"
        d="M14 12.227l-2.351 1.676.867-2.754-2.32-1.718 2.887-.026L14 6.667l.917 2.738 2.887.026-2.32 1.718.867 2.754z"
      />
    </g>
  </svg>
);

export default SvgBf;
